import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Conversation } from '../models/conversation';
import { ConvsService } from '../services/convs.service';
import { JobsService } from '../services/jobs.service';
import { SidebarService } from '../services/sidebar.service';

@Component({
  selector: 'app-sidebar-conv-list',
  templateUrl: './sidebar-conv-list.component.html',
  styleUrls: ['./sidebar-conv-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarConvListComponent implements OnInit {
  @Input() bottom = false;
  @Input() convs: Conversation[] = [];
  @Input() inboxType: string;
  @Input() loading = false;
  @Input() aiEnabled = false;
  @Output() scrolled = new EventEmitter();

  inboxSortBy$ = this.convsService.inboxSortBy.asObservable();

  constructor(
    public sidebarService: SidebarService,
    public jobsService: JobsService,
    public convsService: ConvsService
  ) {}

  ngOnInit() {}

  onScroll() {
    this.scrolled.emit();
  }

  changeConversationSorting(sortBy: 'lastEventDate' | 'ai_scores.engagement') {
    this.convsService.setInboxSortBy(sortBy);
  }
}
